import './Collapse.scss';

import React from 'react';

interface Props {
  isOpen: boolean;
  children?: any;
}

const Collapse = (props: Props) => {
  return (
    <div className={`Collapse ${props.isOpen ? '' : 'collapsed'}`}>
      {props.isOpen && props.children}
    </div>
  );
};

export default Collapse;
